import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import isEmptyObject from '../../util/isEmptyObject';
import { AppContext } from '../../util/AppContext';
import { getConfigValue } from '../../util/getConfigValue';
import { useErrorBoundary } from 'react-error-boundary';
import { useBreadcrumbs } from '../../util/BreadcrumbContext';
import PageTitle from '../../components/PageTitle';
import AddressDetails from '../../components/AddressEntry';

function AddressPageEdit() {
	const [appState] = useContext(AppContext);
	const { state: locationState } = useLocation(); // pull state, rename as locationState to avoid conflict

	const [currentAddress, setCurrentAddress] = useState(locationState.address || {});
	const [addMode, setAddMode] = useState(isEmptyObject(currentAddress) ? true : false);
	const [isSaving, setIsSaving] = useState(false);
	const [hasSaved, setHasSaved] = useState(false);
	const { showBoundary } = useErrorBoundary();

	const childRef = useRef(null);

	const handleClick = () => {
		childRef.current.onSubmitForm();
	};

	const handleSave = () => {
		setIsSaving(false);
		setHasSaved(true);
		if (addMode) {
			navigate(-1, {
				state: {
					alert: {
						type: 'success',
						heading: getConfigValue(appState?.config?.AddressPage?.Success?.Title, appState)?.Value || null,
						message: getConfigValue(appState?.config?.AddressPage?.Messages?.Add?.Success, appState)?.Value || null,
					},
				},
			});
		} else {
			navigate(-1, {
				state: {
					alert: {
						type: 'success',
						heading: getConfigValue(appState?.config?.AddressPage?.Success?.Title, appState)?.Value || null,
						message: getConfigValue(appState?.config?.AddressPage?.Messages?.Update?.Success, appState)?.Value || null,
					},
				},
			});
		}
	};

	const handleSaveError = () => {
		setIsSaving(false);
		setHasSaved(true);
	};

	const pageTitle = addMode
		? getConfigValue(appState?.config?.AddressPage?.Title?.Add, appState)?.Value || null
		: getConfigValue(appState?.config?.AddressPage?.Title?.Edit, appState)?.Value || null;

	const saveButtonLabel = addMode
		? getConfigValue(appState?.config?.AddressPage?.Button?.Add, appState)?.Value || null
		: getConfigValue(appState?.config?.AddressPage?.Button?.Save, appState)?.Value || null;

	const navigate = useNavigate();
	const { setBreadcrumbs } = useBreadcrumbs();

	useEffect(() => {
		setBreadcrumbs([
			{ label: 'Addresses', path: '/AddressPage' },
			{ label: pageTitle, path: '' },
		]);
	}, [setBreadcrumbs]);

	return (
		<>
			<div className='container-xxl mt-4'>
				<div className='row justify-content-center'>
					<div className='col-12 col-md-10 col-lg-8 mb-4 my-0'>
						<PageTitle title={pageTitle} />
					</div>
				</div>
			</div>

			<div className='container-xxl'>
				<div className='row justify-content-center'>
					<div className='col-12 col-md-10 col-lg-8'>
						<AddressDetails ref={childRef} onSave={handleSave} onError={handleSaveError} currentAddress={currentAddress} />
						<div className='row justify-content-center justify-content-md-end'>
							<div className='col-12 col-sm-8 col-md-8 col-lg-7 col-xl-6'>
								<div className='d-flex flex-column flex-md-row-reverse'>
									<button
										disabled={isSaving ? true : null}
										onClick={handleClick}
										className={`btn ${isSaving && !hasSaved ? 'btn-working' : ''} btn-success btn-lg mb-3 mb-md-0 ms-md-3 flex-fill w-100`}
									>
										{saveButtonLabel}
									</button>

									<button disabled={isSaving ? true : null} onClick={() => navigate(-1)} className='btn btn-secondary btn-lg flex-fill w-100'>
										{getConfigValue(appState?.config?.Common?.Cancel, appState)?.Value || null}
									</button>
								</div>
							</div>
						</div>
						<div className='mb-7'></div>
					</div>
				</div>
			</div>
		</>
	);
}

export default AddressPageEdit;
